// extracted by mini-css-extract-plugin
export var active = "_1v-9";
export var backButton = "_1v-8";
export var clone = "_1v-e";
export var collapseBar = "_1v-k";
export var collapseMode = "_1v-m";
export var collapsed = "_1v-o";
export var dimmed = "_1v-i";
export var dragHandle = "_1v-c";
export var dropdownIcon = "_1v-g";
export var expanding = "_1v-n";
export var hidden = "_1v-x";
export var iconContainer = "_1v-q";
export var iconSwapper = "_1v-w";
export var navItem = "_1v-6";
export var navItemIcon = "_1v-f";
export var navProfile = "_1v-7";
export var notificationCountBadge = "_1v-j";
export var notificationDot = "_1v-r";
export var optionsContainer = "_1v-h";
export var primaryNav = "_1v-0";
export var primaryNavDivider = "_1v-v";
export var primaryNavResizeHandle = "_1v-2";
export var primaryNavResizing = "_1v-1";
export var primaryNavTabSection = "_1v-u";
export var primaryTab = "_1v-p";
export var primaryTabIconBox = "_1v-s";
export var secondaryNav = "_1v-3";
export var selected = "_1v-t";
export var settingsNav = "_1v-4";
export var settingsNavItems = "_1v-5";
export var show = "_1v-d";
export var sideNav = "_1v-l";
export var teamItem = "_1v-a";
export var userProfileItem = "_1v-b";